import { call, put, takeLatest, all } from 'redux-saga/effects';
import { apiWithUrlParams } from '../../lib/apiMiddleware/apiMiddleware';
import * as types from '../../lib/constants';

const isCountDown = (date) => {
  const start = new Date(date).getTime();
  const now = Date.now();
  const timeDiff = start - now;
  if (timeDiff < 0) {
    return -1;
  } else if (timeDiff <= 3600000) {
    return 1;
  }
  return 0;
};

function* getBasketLineups(action) {
  const urlParams = {
    sportId: action.sportId,
    competitionId: action.competitionId,
    matchId: action.matchId,
  };
  try {
    const { data } = yield call(apiWithUrlParams, 'match', 'getLineups', urlParams);
    yield put({ type: types.GET_LINEUPS_BASKET_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.GET_LINEUPS_BASKET_ERROR, error });
  }
}

function* getProb(action) {
  const { competitionId, matchInfo } = action;
  // squadHome = (matchInfo.homeTeam.teamName).toLowerCase().replace(' ', '-');
  //const squadAway = (matchInfo.awayTeam.teamName).toLowerCase().replace(' ', '-');
  const squadHomeId = matchInfo.homeTeam.teamId;
  const squadAwayId = matchInfo.awayTeam.teamId;
  yield all([
    put({ type: types.GET_PROBABILI_HOME_REQUEST, squad: squadHomeId, competitionId }),
    put({ type: types.GET_PROBABILI_AWAY_REQUEST, squad: squadAwayId, competitionId }),
    put({ type: types.GET_PROBABILI_SUCCESS, data: { squadHomeId, squadAwayId } }),
  ]);
}

function* getLineups(action) {
  const urlParams = {
    teamId: action.teamId,
    sportId: action.sportId,
    competitionId: action.competitionId,
    version: 'v2',
  };
  try {
    let callXml = true;
    let matchInfo = yield call(apiWithUrlParams, 'widgets', 'getNextMatch', urlParams);
    matchInfo = matchInfo.data;
    yield put({ type: types.GET_MATCHINFO_SUCCESS, matchInfo, teamId: action.teamId });
    if (isCountDown(matchInfo.date) !== 0) {
      const matchUrlParams = {
        sportId: urlParams.sportId,
        competitionId: urlParams.competitionId,
        matchId: matchInfo.matchId,
      };
      const { data } = yield call(apiWithUrlParams, 'match', 'getLineups', matchUrlParams);
      if (data.homeTeam) {
        callXml = false;
        yield put({ type: types.GET_LINEUPS_SUCCESS, data });
      }
    }
    if (callXml) {
      const { competitionId } = urlParams;
      yield put({ type: types.GET_LINEUPS_SUCCESS, data: {} });
      yield getProb({ competitionId, matchInfo });
    }
  } catch (error) {
    yield put({ type: types.GET_LINEUPS_ERROR, error });
    yield getProb(action);
  }
}

function* watchGetLineups() {
  yield takeLatest(types.GET_LINEUPS_REQUEST, getLineups);
}

function* watchGetBasketLineups() {
  yield takeLatest(types.GET_LINEUPS_BASKET_REQUEST, getBasketLineups);
}

export default [
  watchGetLineups,
  watchGetBasketLineups,
];



// WEBPACK FOOTER //
// ./src/demo/sagas/lineups.js